/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WidgetsRouteImport } from './routes/widgets'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CollectionPagesRouteImport } from './routes/collection-pages'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WidgetsIndexRouteImport } from './routes/widgets.index'
import { Route as CollectionPagesIndexRouteImport } from './routes/collection-pages.index'
import { Route as WidgetsNewRouteImport } from './routes/widgets.new'
import { Route as CollectionPagesNewRouteImport } from './routes/collection-pages.new'
import { Route as CollectionPagesIdRouteImport } from './routes/collection-pages.$id'
import { Route as WidgetsIdEmbedRouteImport } from './routes/widgets.$id.embed'
import { Route as WidgetsIdEditRouteImport } from './routes/widgets.$id.edit'

const WidgetsRoute = WidgetsRouteImport.update({
  id: '/widgets',
  path: '/widgets',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TestimonialsRoute = TestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionPagesRoute = CollectionPagesRouteImport.update({
  id: '/collection-pages',
  path: '/collection-pages',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WidgetsIndexRoute = WidgetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WidgetsRoute,
} as any)
const CollectionPagesIndexRoute = CollectionPagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CollectionPagesRoute,
} as any)
const WidgetsNewRoute = WidgetsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WidgetsRoute,
} as any)
const CollectionPagesNewRoute = CollectionPagesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CollectionPagesRoute,
} as any)
const CollectionPagesIdRoute = CollectionPagesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CollectionPagesRoute,
} as any)
const WidgetsIdEmbedRoute = WidgetsIdEmbedRouteImport.update({
  id: '/$id/embed',
  path: '/$id/embed',
  getParentRoute: () => WidgetsRoute,
} as any)
const WidgetsIdEditRoute = WidgetsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => WidgetsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/collection-pages': typeof CollectionPagesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/testimonials': typeof TestimonialsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/widgets': typeof WidgetsRouteWithChildren
  '/collection-pages/$id': typeof CollectionPagesIdRoute
  '/collection-pages/new': typeof CollectionPagesNewRoute
  '/widgets/new': typeof WidgetsNewRoute
  '/collection-pages/': typeof CollectionPagesIndexRoute
  '/widgets/': typeof WidgetsIndexRoute
  '/widgets/$id/edit': typeof WidgetsIdEditRoute
  '/widgets/$id/embed': typeof WidgetsIdEmbedRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/testimonials': typeof TestimonialsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/collection-pages/$id': typeof CollectionPagesIdRoute
  '/collection-pages/new': typeof CollectionPagesNewRoute
  '/widgets/new': typeof WidgetsNewRoute
  '/collection-pages': typeof CollectionPagesIndexRoute
  '/widgets': typeof WidgetsIndexRoute
  '/widgets/$id/edit': typeof WidgetsIdEditRoute
  '/widgets/$id/embed': typeof WidgetsIdEmbedRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/collection-pages': typeof CollectionPagesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/testimonials': typeof TestimonialsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/widgets': typeof WidgetsRouteWithChildren
  '/collection-pages/$id': typeof CollectionPagesIdRoute
  '/collection-pages/new': typeof CollectionPagesNewRoute
  '/widgets/new': typeof WidgetsNewRoute
  '/collection-pages/': typeof CollectionPagesIndexRoute
  '/widgets/': typeof WidgetsIndexRoute
  '/widgets/$id/edit': typeof WidgetsIdEditRoute
  '/widgets/$id/embed': typeof WidgetsIdEmbedRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/collection-pages'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/testimonials'
    | '/verify-email'
    | '/widgets'
    | '/collection-pages/$id'
    | '/collection-pages/new'
    | '/widgets/new'
    | '/collection-pages/'
    | '/widgets/'
    | '/widgets/$id/edit'
    | '/widgets/$id/embed'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/testimonials'
    | '/verify-email'
    | '/collection-pages/$id'
    | '/collection-pages/new'
    | '/widgets/new'
    | '/collection-pages'
    | '/widgets'
    | '/widgets/$id/edit'
    | '/widgets/$id/embed'
  id:
    | '__root__'
    | '/'
    | '/collection-pages'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/testimonials'
    | '/verify-email'
    | '/widgets'
    | '/collection-pages/$id'
    | '/collection-pages/new'
    | '/widgets/new'
    | '/collection-pages/'
    | '/widgets/'
    | '/widgets/$id/edit'
    | '/widgets/$id/embed'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CollectionPagesRoute: typeof CollectionPagesRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  TestimonialsRoute: typeof TestimonialsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WidgetsRoute: typeof WidgetsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/widgets': {
      id: '/widgets'
      path: '/widgets'
      fullPath: '/widgets'
      preLoaderRoute: typeof WidgetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testimonials': {
      id: '/testimonials'
      path: '/testimonials'
      fullPath: '/testimonials'
      preLoaderRoute: typeof TestimonialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collection-pages': {
      id: '/collection-pages'
      path: '/collection-pages'
      fullPath: '/collection-pages'
      preLoaderRoute: typeof CollectionPagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/widgets/': {
      id: '/widgets/'
      path: '/'
      fullPath: '/widgets/'
      preLoaderRoute: typeof WidgetsIndexRouteImport
      parentRoute: typeof WidgetsRoute
    }
    '/collection-pages/': {
      id: '/collection-pages/'
      path: '/'
      fullPath: '/collection-pages/'
      preLoaderRoute: typeof CollectionPagesIndexRouteImport
      parentRoute: typeof CollectionPagesRoute
    }
    '/widgets/new': {
      id: '/widgets/new'
      path: '/new'
      fullPath: '/widgets/new'
      preLoaderRoute: typeof WidgetsNewRouteImport
      parentRoute: typeof WidgetsRoute
    }
    '/collection-pages/new': {
      id: '/collection-pages/new'
      path: '/new'
      fullPath: '/collection-pages/new'
      preLoaderRoute: typeof CollectionPagesNewRouteImport
      parentRoute: typeof CollectionPagesRoute
    }
    '/collection-pages/$id': {
      id: '/collection-pages/$id'
      path: '/$id'
      fullPath: '/collection-pages/$id'
      preLoaderRoute: typeof CollectionPagesIdRouteImport
      parentRoute: typeof CollectionPagesRoute
    }
    '/widgets/$id/embed': {
      id: '/widgets/$id/embed'
      path: '/$id/embed'
      fullPath: '/widgets/$id/embed'
      preLoaderRoute: typeof WidgetsIdEmbedRouteImport
      parentRoute: typeof WidgetsRoute
    }
    '/widgets/$id/edit': {
      id: '/widgets/$id/edit'
      path: '/$id/edit'
      fullPath: '/widgets/$id/edit'
      preLoaderRoute: typeof WidgetsIdEditRouteImport
      parentRoute: typeof WidgetsRoute
    }
  }
}

interface CollectionPagesRouteChildren {
  CollectionPagesIdRoute: typeof CollectionPagesIdRoute
  CollectionPagesNewRoute: typeof CollectionPagesNewRoute
  CollectionPagesIndexRoute: typeof CollectionPagesIndexRoute
}

const CollectionPagesRouteChildren: CollectionPagesRouteChildren = {
  CollectionPagesIdRoute: CollectionPagesIdRoute,
  CollectionPagesNewRoute: CollectionPagesNewRoute,
  CollectionPagesIndexRoute: CollectionPagesIndexRoute,
}

const CollectionPagesRouteWithChildren = CollectionPagesRoute._addFileChildren(
  CollectionPagesRouteChildren,
)

interface WidgetsRouteChildren {
  WidgetsNewRoute: typeof WidgetsNewRoute
  WidgetsIndexRoute: typeof WidgetsIndexRoute
  WidgetsIdEditRoute: typeof WidgetsIdEditRoute
  WidgetsIdEmbedRoute: typeof WidgetsIdEmbedRoute
}

const WidgetsRouteChildren: WidgetsRouteChildren = {
  WidgetsNewRoute: WidgetsNewRoute,
  WidgetsIndexRoute: WidgetsIndexRoute,
  WidgetsIdEditRoute: WidgetsIdEditRoute,
  WidgetsIdEmbedRoute: WidgetsIdEmbedRoute,
}

const WidgetsRouteWithChildren =
  WidgetsRoute._addFileChildren(WidgetsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CollectionPagesRoute: CollectionPagesRouteWithChildren,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  TestimonialsRoute: TestimonialsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WidgetsRoute: WidgetsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
